import { Sprite } from './sprite';

/**
 * 整数から数値のスプライトを取得するクラス
 */
export class ImageNumber {
  private readonly numbers: Sprite[] = [];
  public readonly width: number;
  public readonly height: number;

  public constructor(source: CanvasImageSource, width: number, height: number) {
    this.width = width;
    this.height = height;

    for (let i = 0; i < 10; i++) {
      const sprite = new Sprite(width, height);
      sprite.context.drawImage(source, width * i, 0, sprite.width, sprite.height, 0, 0, sprite.width, sprite.height);
      this.numbers.push(sprite);
    }
  }

  public get(number: number) {
    const index = Math.max(0, number) % 10;

    return this.numbers[index];
  }
}
